import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Text,
} from '@chakra-ui/react';

import { useModalManagerContext } from '../../components/ModalManager/ModalManagerContext';

const FrequencyEditorStep1Modal: React.FC = () => {
  const { t } = useTranslation();
  const {
    goToFirstStep,
    jumpSteps,
    loadNextFlowStep,
  } = useModalManagerContext();

  return (
    <>
      <ModalHeader>{t('cancelModal.frequency.modalTitle')}</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Box>
          <Text variant="strong">{t('cancelModal.frequency.title')}</Text>
          <Text>{t('cancelModal.frequency.subtitle')}</Text>
          <Button onClick={loadNextFlowStep} variant="outlinedBig">
            {t('cancelModal.frequency.updateFrequency')}
          </Button>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Button mr="4" onClick={goToFirstStep} variant="outlinedBig">
          {t('cancelModal.back')}
        </Button>
        <Button onClick={() => jumpSteps(1)} variant="blackBig">
          {t('cancelModal.continueWithCancellation')}
        </Button>
      </ModalFooter>
    </>
  );
};

export default FrequencyEditorStep1Modal;
